import modelsStore from '@/lib/services/models-store';
import store from '@/store';

import {
  FORM_TYPE,
} from '@/lib/constants/model-types';

const hasDuplicates = array => new Set(array).size !== array.length;

const nameValidation = () => {
  const mainForm = modelsStore.modelForName(
    FORM_TYPE,
    store.state.formData.mainFormName,
  );

  const currentStepsNames = mainForm.steps.map(step => step.name);

  if (hasDuplicates(currentStepsNames)) {
    throw new Error('Used step name is already declared');
  }

  const currentFieldsets = mainForm.steps.reduce((acc, step) => [...acc, ...step.fieldsets], []);

  const currentFieldsetsNames = currentFieldsets.map(fieldset => fieldset.name);

  if (hasDuplicates(currentFieldsetsNames)) {
    throw new Error('Used fieldset name is already declared');
  }

  return true;
};

export default nameValidation;
